/**
 * Language resource for validation messages.
 * @typedef {Object} ValidationMessages
 * @property {string} question - Validation message for the question field when it's empty.
 * @property {string} validQuestion - Validation message for the question field when it's not valid.
 * @property {string} typeOfFaqs - Validation message for the type of FAQs field when it's empty.
 * @property {string} answer - Validation message for the answer field when it's empty.
 * @property {string} minPhone - Validation message for the phone number field when it's less than the minimum length.
 * @property {string} phoneNumber - Validation message for the phone number field when it's empty.
 * @property {string} addressReq - Validation message for the address field when it's empty.
 * @property {string} emailReq - Validation message for the email field when it's empty.
 * @property {string} termsAndConditions - Validation message for the terms and conditions field when it's empty.
 * @property {string} privacyPolicy - Validation message for the privacy policy field when it's empty.
 */

/**
 * Language resource for validation messages.
 * @type {ValidationMessages}
 */

export const validation = {
  question: "Question is required",
  validQuestion: "Please enter valid Question",
  typeOfFaqs: "Type Of faqs is required",
  answer: "Answer is required",
  minPhone: "Phone number must be 6 to 16 digits",
  phoneNumber: "phone number is required",
  addressReq: "Address is required",
  emailReq: "Email is required",
  termsAndConditions: "Terms and Conditions is required",
  privacyPolicy: "Privacy Policy is required",
};
